module.exports = __webpack_public_path__ + "img/user-06.9ed53048.jpg";